import {FC, useState} from "react";
import {Box} from "@material-ui/core";
import {useStateValue} from "../state-provider/StateProvider";
import {setGridAreaContent} from "../app/App.action";
import {TfiBolt} from "react-icons/tfi";
import classnames from "classnames";
import './ShareCounterIconButton.css'

export const ShareCounterIconButton: FC<{

}> = ({

}) => {

  const [ { shareJoinedCount }, dispatch ] = useStateValue()
  const [mouseDown, setMouseDown] = useState(false)

  return (
    <Box
      className={classnames('share-counter-icon-button', mouseDown ? 'mouse-down' : '')}
      onMouseDown={e => {
        e.preventDefault()
        e.stopPropagation()
        setMouseDown(true)
      }}
      onMouseUp={e => {
        e.preventDefault()
        e.stopPropagation()
        setMouseDown(false)
      }}
      onClick={e => {
        e.preventDefault()
        e.stopPropagation()
        dispatch(setGridAreaContent('ShareBoost'))
      }}
    >
      <span>
        +{shareJoinedCount}
      </span>
      <TfiBolt size={24} style={{ marginLeft: -5 }}/>
    </Box>
  )
}